import logger from '../utils/rbata.logger';
import gigya from '../gigya/rbata.gigya';
import gigyaLiteRegistration from '../gigya/rbata.lite-registration';
import cookieUtils from '../utils/rbata.cookie-utils';

const newsletterModal = {
    $newsletterBtn:     undefined,
    $newsletterModal:   undefined,
    $newsletterWrapper: undefined,
    timeToTriggerModal: 0, // 0 means it will be turned off by default
    $shouldShowModal:   undefined,
    nlCookieKey:        'nlModalWasClosed',
    isUserSubscribed:   undefined,

    init() {
        this.isUserSubscribed = gigya.readCookie(gigyaLiteRegistration.newsletterCookieName);
        this.newsletterPopupBanner = $('.js-newsletter-popup');
        this.$newsletterBtn        = $('#js-newsletter-modal-trigger');
        this.$newsletterModal      = $('#js-newsletter-modal');
        this.$newsletterWrapper    = $('.js-newsletter-wrapper');
        // Time is configured in BO in seconds on popup wrapper component
        this.timeToTriggerModal = (this.$newsletterWrapper.data('delay-seconds') ?? this.timeToTriggerModal) * 1000;
        this.$shouldShowModal = ($('.page-productDetailPage').length || $('.page-productListPage').length || $('.page-landingPage').length)
                && cookieUtils.readCookie(newsletterModal.nlCookieKey) !== 'true' && newsletterModal.timeToTriggerModal > 0;
    },

    bindCartActions() {
        // banner in cart area and order confirmation should trigger modal
        this.$newsletterBtn.on('click', () => {
            this.$newsletterModal.modal('show');
        });
    },

    checkUserSubscription() {
        if (!window.isGigyaUserAuthenticated) {
            if (!newsletterModal.isUserSubscribed) {
                newsletterModal.newsletterTimerPopup();
            } else {
                logger.log('It is detected from the cookie that anonymous user is subscribed already, NL popup will not be shown');
            }
        } else {
            gigya.isUserSubscribedToNewsletter().then((isUserSubscribedResponse) => {
                if (!isUserSubscribedResponse) {
                    newsletterModal.newsletterTimerPopup();
                } else {
                    logger.log('Logged in user is subscribed already, NL popup will not be shown');
                }
            });
        }
    },

    newsletterTimerPopup() {
        // Trigger NL modal after configured time
        // Only HP, PLP, PDP

        setTimeout(() => {
            newsletterModal.$newsletterModal.modal('show');
            logger.log(`*** NL modal triggered after ${newsletterModal.timeToTriggerModal}ms ***`);
        }, newsletterModal.timeToTriggerModal);

        newsletterModal.$newsletterModal.on('hidden.bs.modal', function () {
            cookieUtils.createCookie(newsletterModal.nlCookieKey, true)
        });

    },

    newsletterPopupInit() {
        newsletterModal.init();

        if (newsletterModal.$shouldShowModal) {
            newsletterModal.checkUserSubscription();
        } else {
            logger.log('Nl popup will not be shown: It is already closed OR timing may be 0 OR page is not an PLP, PDP or Homepage');
        }

        if (newsletterModal.newsletterPopupBanner.length) {
            newsletterModal.bindCartActions();
        }
    }
};

export default newsletterModal;
